// Server store slice types and initial state

// ─── Types ───────────────────────────────────────────────────────────

export interface Server {
  id: number;
  customer_id: number;
  customer_username: string;
  customer_display_name: string | null;
  server_uuid: string;
  name: string;
  public_host: string;
  https_port: number;
  site_id: string;
  version: string;
  agent_count: number;
  blade_count: number;
  last_heartbeat: string;
  created_at: string;
  status: 'online' | 'offline';
}

// ─── Slice State Interface ───────────────────────────────────────────

export interface ServerState {
  servers: Server[];
  isLoading: boolean;
  error: string | null;
}

// ─── Initial State ───────────────────────────────────────────────────

export const initialServerState: ServerState = {
  servers: [],
  isLoading: false,
  error: null,
};
